var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantBankTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.771 4a7.47 7.47 0 00-.252 1.5H3.5V8h7.271c.198.715.5 1.387.886 2H3.5v8.5h17v-5.429a7.467 7.467 0 001.5-.73V20H3a1 1 0 01-1-1V4h8.771z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15a1 1 0 110 2H6a1 1 0 110-2h4zM18.6 2.5c.153 0 .27.133.252.284l-.285 2.365c-.018.152.1.284.252.285h1.152c.213 0 .331.247.198.413l-2.857 3.558a.255.255 0 01-.198.095h-.026a.254.254 0 01-.251-.29l.277-2.001a.255.255 0 00-.252-.29h-.887a.254.254 0 01-.211-.394l2.608-3.912a.254.254 0 01.211-.113h.018z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.309.008A6 6 0 0124 6l-.008.309A6 6 0 0118 12l-.309-.008a6 6 0 01-5.683-5.683L12 6a6 6 0 016-6l.309.008zM18 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    fill: "currentColor"
  })));
}
SvgInstantBankTransfer.displayName = 'InstantBankTransfer';
export default SvgInstantBankTransfer;